import { Directive, HostListener, AfterViewInit } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[formControlName][vaultPhoneMask]',
  standalone: false,
})
export class PhoneMaskDirective implements AfterViewInit {
  constructor(public ngControl: NgControl) {}

  ngAfterViewInit() {
    if (this.ngControl.control.value) {
      this.onInputChange(this.ngControl.control.value);
    }
  }

  @HostListener('ngModelChange', ['$event'])
  onModelChange(event: any) {
    this.onInputChange(event);
  }

  onInputChange(event: string) {
    if (!event) {
      return;
    }

    const val = event.replace(/\D/g, '').match(/(\d{0,3})(\d{0,3})(\d{0,4})/);

    const formattedValue = !val[2]
      ? val[1]
      : `(${val[1]}) ${val[2]}` + (val[3] ? `-${val[3]}` : ``);

    this.ngControl.valueAccessor.writeValue(formattedValue);
  }
}
